import React, { useCallback, useEffect, useMemo } from 'react'
import styles from 'components/TicketsPanel/tickets-panel.module.scss'
import clsx from 'clsx'
import Ticket from 'modules/Tickets/Chat'
import TicketList from 'modules/Tickets/List'
import { Button, Icon } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useDispatch, useSelector } from 'react-redux'
import { PANEL_NAVIGATE, TOGGLE_PANEL } from 'modules/Tickets/types'
import GridSpinner from 'components/UI/GridSpinner'

const LAYOUTS = {
  list: TicketList,
  ticket: Ticket,
  new_ticket: Ticket,
}

const NoopComponent = () => <GridSpinner />

const Panel = () => {
  const dispatch = useDispatch()
  const breakpoints = useBreakpoint()
  const { openPanel, router: ticketPanelRouter } = useSelector(({ tickets }) => tickets)

  const LayoutComponent = useMemo(() => {
    return LAYOUTS[ticketPanelRouter.route] || NoopComponent
  }, [ticketPanelRouter])

  const navTo = useCallback((newRoute) => {
    dispatch({ type: PANEL_NAVIGATE, payload: newRoute })
  }, [])

  useEffect(() => {
    if (!ticketPanelRouter.route && openPanel) {
      dispatch({ type: PANEL_NAVIGATE, payload: { route: 'list', params: {} } })
    }

    document.querySelector('body').classList.toggle('body_overflow_hidden', openPanel)
  }, [openPanel])

  return (
    <>
      <div
        className={clsx(styles['tickets-panel__overlay'], {
          [styles['tickets-panel__overlay_open']]: openPanel,
        })}
        onClick={() => dispatch({ type: TOGGLE_PANEL, payload: false })}
      />
      <div
        className={clsx(styles['tickets-panel__container'], {
          [styles['tickets-panel__container_open']]: openPanel,
        })}
      >
        <div className={clsx(styles['tickets-panel__content'], 'layout-tile')}>
          <LayoutComponent
            closeButton={
              <Button
                color={'Interface-Seventh'}
                colorHover={'Interface-Eight'}
                className={styles['tickets-panel__close-button']}
                onClick={() => dispatch({ type: TOGGLE_PANEL, payload: false })}
                noLabel
                variant={'ghost'}
                grey
                size={!breakpoints.md ? 's' : 'm'}
                startIcon={<Icon name={'close'} />}
              />
            }
            navTo={navTo}
            params={ticketPanelRouter.params}
          />
        </div>
      </div>
    </>
  )
}

export default Panel
